import { render, staticRenderFns } from "./PolicyDetails.vue?vue&type=template&id=1c067e10"
import script from "./PolicyDetails.vue?vue&type=script&lang=js"
export * from "./PolicyDetails.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetails.vue?vue&type=style&index=0&id=1c067e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports